export const ACCOUNT_DETAIL_FIELDS = {
	ID: 'ID:',
	DOT: 'Dot:',
	PLAN: 'Plan:',
	NAME: 'Name:',
	MC: 'MC:',
	CREATED_AT: 'Created at:',
	FROM_EMAIL: 'From Email:',
	DAYS_TO_PAY: 'Days To Pay:',
	SYSTEM_NAME: 'System Name:',
	API_TOKEN: 'API Token:',
};
